export const ActionTypes = {
    Authenticated: 'APP_USER_AUTHENTICATED',
    BootstrapMessage: 'APP_BOOTSTRAP_MESSAGE',
    ClearSelected: 'APP_CLEAR_SELECTED',
    ClearSelectedWell: 'APP_CLEAR_SELECTED_WELL',
    EventsChange: 'APP_EVENTS_CHANGE',
    EventsReset: 'APP_EVENTS_RESET',
    HierarchyFilter: 'APP_HIERARCHY_FILTER',
    HierarchyFilterClear: 'APP_HIERARCHY_FILTER_CLEAR',
    HierarchyLoaded: 'APP_HIERARCHY_LOADED',
    HierarchyUpdated: 'APP_HIERARCHY_UPDATED',
    UpdateUser: 'APP_UPDATE_USER',
    NodeMoved: 'APP_NODE_MOVED',
    RunningStatusReceived: 'APP_RUNNING_STATUS_RECEIVED',
    WatchListCreated: 'APP_WATCHLIST_CREATED',
    WatchListDeleted: 'APP_WATCHLIST_DELETED',
    WatchListsLoaded: 'APP_WATCHLISTS_LOADED',
    ZediMigrationComplete: 'APP_ZEDI_MIGRATION_COMPLETE',

    // Server notifications
    ServerEventAlertSent: 'SERVER_NOTIFICATION_EVENT_ALERT_SENT',
    ServerHierarchyAdded: 'SERVER_NOTIFICATION_HIERIARCHY_ADDED',
    ServerHierarchyDeleted: 'SERVER_NOTIFICATION_HIERIARCHY_DELETED',
    ServerHierarchyMoved: 'SERVER_NOTIFICATION_HIERIARCHY_MOVED',
    ServerHierarchyUpdated: 'SERVER_NOTIFICATION_HIERIARCHY_UPDATED',
    ServerSystemMessage: 'SERVER_NOTIFICATION_SYSTEM_MESSAGE',
};
